import React from 'react'
import PropTypes from 'prop-types'

class CheckoutComplete extends React.Component {
  constructor(props) {
    super(props);
    this.onClick = this.onClick.bind(this);
  }

  onClick() {
    this.props.onCompleteCheckout(this.props.placeOrderDetails);
  }

  render() {
    return (
      <div className={`summary-complete-checkout text-center px-2 pb-2 ${this.props.additionalClassname && this.props.additionalClassname}`}>
        {this.props.onPaymentScreen && this.props.usingPo &&
          <button
            className='btn btn-red d-flex justify-content-between '
            disabled={this.props.isPlaceOrderPending}
            onClick={(e) => this.onClick(e)}
          >
            {this.props.buttonText}
            {this.props.isPlaceOrderPending &&
              <span className={`fas fa-spinner fa-spin ml-2`} />}
          </button>
        }
      </div>
    );
  }
}

CheckoutComplete.propTypes = {
  onCompleteCheckout: PropTypes.func.isRequired,
  buttonText: PropTypes.string.isRequired,
  continueButtonText: PropTypes.string.isRequired,
  placeOrderDetails: PropTypes.object.isRequired,
  additionalClassname: PropTypes.string,
  isPlaceOrderPending: PropTypes.bool,
  backButtonText: PropTypes.string,
  onBack: PropTypes.func,
  onContinueClick: PropTypes.func,
  usingPo: PropTypes.bool,
}



export default CheckoutComplete
